import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdDisplay = ({ position, style = {} }) => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/banners/active?position=${position}`)
      .then(r => setBanners(r.data || []))
      .catch(() => {});
  }, [position]);

  const [selectedBanner, setSelectedBanner] = useState(null);

  useEffect(() => {
    if (banners.length > 0) {
      setSelectedBanner(banners[Math.floor(Math.random() * banners.length)]);
    }
  }, [banners]);

  if (!selectedBanner) return null;

  const banner = selectedBanner;

  const handleClick = () => {
    axios.post(`${BACKEND_URL}/api/banners/${banner.id}/click`).catch(() => {});
    if (banner.target_url) window.open(banner.target_url, '_blank');
  };

  return (
    <div className={`ad-slot ad-${position}`} style={style} onClick={handleClick}>
      <div className="ad-label">AD</div>
      {banner.image_url ? (
        <img loading="lazy" src={banner.image_url} alt={banner.alt_text || 'Advertisement'} className="ad-image" />
      ) : (
        <div className="ad-placeholder">
          <span>Advertisement</span>
        </div>
      )}
    </div>
  );
};

export const PopupAd = ({ onClose }) => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/banners/active?position=popup`)
      .then(r => {
        if (r.data && r.data.length > 0) {
          setBanner(r.data[Math.floor(Math.random() * r.data.length)]);
        }
      }).catch(() => {});
  }, []);

  if (!banner) return null;

  const handleClick = () => {
    axios.post(`${BACKEND_URL}/api/banners/${banner.id}/click`).catch(() => {});
    if (banner.target_url) window.open(banner.target_url, '_blank');
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={e => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose}>✕</button>
        <div onClick={handleClick} style={{ cursor: 'pointer' }}>
          {banner.image_url ? (
            <img loading="lazy" src={banner.image_url} alt={banner.alt_text || 'Ad'} style={{ width: '100%', borderRadius: 12 }} />
          ) : (
            <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>Advertisement</div>
          )}
        </div>
      </div>
    </div>
  );
};

export const PrerollAd = ({ onSkip }) => {
  const [banner, setBanner] = useState(null);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/banners/active?position=preroll`)
      .then(r => {
        if (r.data && r.data.length > 0) {
          setBanner(r.data[Math.floor(Math.random() * r.data.length)]);
        }
      }).catch(() => {});
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      const t = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [countdown]);

  if (!banner) { onSkip(); return null; }

  const handleClick = () => {
    axios.post(`${BACKEND_URL}/api/banners/${banner.id}/click`).catch(() => {});
    if (banner.target_url) window.open(banner.target_url, '_blank');
  };

  return (
    <div className="preroll-overlay">
      <div className="preroll-label">ADVERTISEMENT</div>
      <div className="preroll-content" onClick={handleClick} style={{ cursor: 'pointer' }}>
        {banner.image_url ? (
          <img loading="lazy" src={banner.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#888' }}>Advertisement</div>
        )}
      </div>
      <button className="preroll-skip" onClick={onSkip} disabled={countdown > 0}>
        {countdown > 0 ? `Skip in ${countdown}s` : 'Skip Ad ⏭'}
      </button>
    </div>
  );
};

export default AdDisplay;
